// Limity AI: gdy Limit AI konta albo Limit AI aplikacji jest wyczerpany, API odpowiada 429
// z { code: 'ai_limit', scope: 'account' | 'app', renews_at: 'RRRR-MM-DD' }. Tu: rozpoznanie
// takiej odpowiedzi, jeden wspólny tekst dla każdej funkcji AI i globalny komunikat
// (AiLimitNotice w app.vue), który pokazuje się bez względu na to, która funkcja trafiła na limit.
import { ref } from 'vue';
import { t } from '@/i18n/index.js';
import { intlLocale } from '@/composables/useLanguage.js';

/** Treść odpowiedzi o wyczerpanym limicie z błędu $fetch (albo z samej treści), inaczej null. */
export const aiLimitOf = (e) => {
    const data = e?.data ?? e?.response?._data ?? e;
    return data?.code === 'ai_limit' ? data : null;
};

const renewal = (iso) => {
    if (!iso) return '';
    const [y, m, d] = iso.split('-').map(Number);
    return new Date(y, m - 1, d).toLocaleDateString(intlLocale(), { day: 'numeric', month: 'long' });
};

/** „Wykorzystano miesięczny limit AI. Odnowi się 1 grudnia." / „AI jest chwilowo niedostępne…" — albo null. */
export const aiLimitText = (e) => {
    const limit = aiLimitOf(e);
    if (!limit) return null;
    return limit.scope === 'account'
        ? t('common.aiLimit.account', { date: renewal(limit.renews_at) })
        : t('common.aiLimit.app', { date: renewal(limit.renews_at) });
};

// Ostatni komunikat dla AiLimitNotice — ustawia go useApi przy każdej takiej odpowiedzi.
export const aiLimitNotice = ref(null);
let timer = null;
export const showAiLimitNotice = (data) => {
    aiLimitNotice.value = aiLimitText(data);
    clearTimeout(timer);
    timer = setTimeout(() => { aiLimitNotice.value = null; }, 8000);
};
export const hideAiLimitNotice = () => { aiLimitNotice.value = null; };
